import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setScreenContext } from 'actions/interactableActions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import StandardModalContent from 'GeneralUI/StandardModalContent/StandardModalContent.jsx'
import { closeModal } from 'actions/modalActions'
import { xtractAPI } from 'actions/apiActions'
import { clearNotification } from 'actions/notificationActions'

const TwoFactorSetupRequiredModal = ({ notification }) => {
  const dispatch = useDispatch()
  const messageContent = (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <p style={{ textAlign: 'left', fontSize: '1.2em' }}>
        {notification.body}
      </p>
      <FontAwesomeIcon
        icon={['fas', 'shield-check']}
        style={{
          alignSelf: 'center',
          fontSize: '50px',
          color: 'var(--red-color)'
        }}
        aria-hidden="true"
      />
    </div>
  )

  const goToUserSettings = () => {
    dispatch(clearNotification(notification))
    dispatch(
      xtractAPI(
        `me/notification/${notification.notification_id}`,
        'delete',
        {
          notification_id: notification.notification_id,
          read_at: true
        },
        {
          200: () => {
            dispatch(closeModal(notification.subject.replace(' ', '_')))
            dispatch(
              setScreenContext('nurseDashboard', [{ ref: 'userDetails' }])
            )
          },
          404: () => {
            dispatch(closeModal(notification.subject.replace(' ', '_')))
            dispatch(
              setScreenContext('nurseDashboard', [{ ref: 'userDetails' }])
            )
          } //if its not there anymore we dont need to worry about deleting it
        }
      )
    )
  }

  return (
    <StandardModalContent
      messageContent={messageContent}
      okHandler={goToUserSettings}
      okText={'Setup Two Factor'}
      closeSelf={goToUserSettings}
    />
  )
}

export default TwoFactorSetupRequiredModal
